import React, { createContext, useState } from 'react';

export interface IViewContextValues {
  currentView: string;
  viewsVisited: string[];
  flowName: string;
  goToView: (view: string) => void;
  goBack: () => void;
}

export const ViewContext = createContext<IViewContextValues | null>(null);

export const ViewContextProvider = ({
  children,
  initialView,
  flowName,
}: {
  children: React.ReactNode;
  initialView: string;
  flowName: string;
}) => {
  const [currentView, setCurrentView] = useState<string>(initialView);
  const [viewsVisited, setViewsVisited] = useState<string[]>([initialView]);

  const goToView = (view: string) => {
    setCurrentView(view);
    setViewsVisited((prevState) => prevState.concat(view));
  };

  const goBack = () => {
    setCurrentView(viewsVisited[viewsVisited.length - 2]);
    setViewsVisited((prevState) => prevState.slice(0, -1));
  };

  return (
    <ViewContext.Provider
      value={{
        currentView,
        viewsVisited,

        flowName,
        goToView,
        goBack,
      }}
    >
      {children}
    </ViewContext.Provider>
  );
};
